import React from "react";
import Accordion from "react-bootstrap/Accordion";
import {getParagraph} from "../../../utils/paragraphHelpers";

const AccordionView = ({tabs, accValue, setAccValue}) => {
  return (
    <div className="grid-accordion">
      <Accordion defaultActiveKey="0" onSelect={setAccValue}>
        {tabs?.map((item, index) => (
          <Accordion.Item
            eventKey={`${index}`}
            className={
              accValue === null
                ? ""
                : index === Number(accValue)
                  ? "active"
                  : ""
            }
          >
            <Accordion.Button>
              <p>{item?.field_tab_title}</p>
              <div className="accordion-indicator">
                <i className="icon-caret-up" />
              </div>
            </Accordion.Button>
            <Accordion.Body>
              {item?.relationships?.field_tab_content?.map((node) => getParagraph(node, {tabData: {current: index, selected: accValue}}))}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  )
}

export default AccordionView;